import http from "@/utils/request";
// 校验编码是否重复
export const CheckCodeRepeat = (params) => {
    // 返回一个promise对象
    return http.get("/Common/IsCodeRepeat", params);
};
// 校验密码是否重复
export const CheckPasswordRepeat = (params) => {
    // 返回一个promise对象
    return http.get("/Common/IsPasswordRepeat", params);
};
// 获取最大编码code
export const GetMaxCode = (params) => {
    // 返回一个promise对象
    return http.get("/Common/GetMax_code", params);
};